import { CreditCard, Globe, LineChart, Users, Wrench } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const MODULES = [
  { icon: CreditCard, name: "Winter Pay", desc: "Low-cost money transfers." },
  { icon: LineChart, name: "Market Insights", desc: "Market intelligence and signals." },
  { icon: Users, name: "Trader Marketplace", desc: "Marketplace for traders." },
  { icon: Wrench, name: "Advanced AI Financial Tools", desc: "Future AI-powered financial technology." },
  { icon: Globe, name: "Global Expansion", desc: "Expanding the Winter Protocol ecosystem worldwide." },
];

export default function FutureModules() {
  return (
    <section className="relative py-24 sm:py-32 border-t border-white/[0.06]" data-testid="future-modules-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          chapter="Chapter 06"
          kicker="Future Vision"
          title="The Future Financial Ecosystem."
          subtitle="A pipeline of future products extending Winter Protocol into payments, intelligence, trading communities and global reach."
        />

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {MODULES.map((m, i) => (
            <Reveal key={m.name} delay={i * 0.07} className={i === 4 ? "sm:col-span-2 lg:col-span-1" : ""}>
              <div
                className="group relative h-full glass-card overflow-hidden p-8 transition-all duration-500 hover:border-white/25"
                data-testid={`future-module-${i + 1}`}
              >
                <div className="pointer-events-none absolute -right-10 -top-10 h-36 w-36 rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.12),transparent_70%)] opacity-0 transition-opacity duration-700 group-hover:opacity-100" aria-hidden="true" />
                <div className="flex items-start justify-between">
                  <div className="rounded-xl border border-white/10 bg-white/[0.04] p-3 text-white">
                    <m.icon className="h-5 w-5" />
                  </div>
                  <span className="inline-flex items-center gap-1.5 rounded-full border border-gray-500/30 bg-gray-500/10 px-3 py-1 font-mono text-[10px] tracking-widest text-gray-400 uppercase">
                    <span className="h-1.5 w-1.5 rounded-full bg-gray-500" />
                    Future
                  </span>
                </div>
                <h3 className="mt-6 font-display text-xl font-semibold text-white">{m.name}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#99A1AF]">{m.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
